import { DATA, C, FONT_HEAD, FONT_MONO } from "../data";
import { FaEnvelope, FaGithub, FaInstagram, FaLinkedin, FaMapMarkerAlt } from "react-icons/fa";

function SectionLabel({ num, title }) {
  return (
    <div style={{ marginBottom: "1rem", paddingLeft: "clamp(0px, 15vw, 4.5rem)" }}>
      <div style={{ fontFamily: FONT_MONO, fontSize: "0.72rem", color: C.accentBorder, letterSpacing: "4px", marginBottom: "0.6rem" }}>
        {num + " ───────────"}
      </div>
      <h2 style={{ fontFamily: FONT_HEAD, fontWeight: 800, fontSize: "clamp(1.3rem,4vw,2.6rem)", color: "#fff" }}>
        {title}
      </h2>
    </div>
  );
}
export default function Contact() {
  const contacts = [
    { icon: <FaEnvelope size={20} />,     label: "Email",     val: DATA.email,     href: `mailto:${DATA.email}` },
    { icon: <FaGithub size={20} />,       label: "GitHub",    val: DATA.github,    href: `https://${DATA.github}` },
    { icon: <FaInstagram size={20} />,    label: "Instagram", val: DATA.instagram, href: `https://${DATA.instagram}` },
    { icon: <FaLinkedin size={20} />,     label: "LinkedIn",  val: DATA.linkedin,  href: `https://${DATA.linkedin}` },
    { icon: <FaMapMarkerAlt size={20} />, label: "Location",  val: DATA.location,  href: null },
  ];

  return (
    <div className="anim-fadeup" style={{ padding: "4rem clamp(1.5rem,5vw,4rem)", maxWidth: "900px", margin: "0 auto" }}>
      <SectionLabel num="05" title="Contact" />

      <div style={{ height: "1px", background: `linear-gradient(90deg, ${C.accentBorder}, transparent)`, marginBottom: "3rem", marginLeft: "clamp(0px, 15vw, 4.5rem)" }} />

      <div style={{ maxWidth: "520px", margin: "0 auto", textAlign: "center" }}>
        <p style={{ fontFamily: FONT_MONO, color: C.muted, fontSize: "0.9rem", lineHeight: 1.9, marginBottom: "2.5rem" }}>
          Interested in collaborating or have any questions? Feel free to reach out to me!
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: "0.85rem" }}>
          {contacts.map(({ icon, label, val, href }) => (
            <a key={label} href={href || "#"} target="_blank" rel="noreferrer" className="contact-row" style={{
              display: "flex", alignItems: "center", gap: "1rem",
              background: C.card, border: `1px solid ${C.cardBorder}`,
              borderRadius: "8px", padding: "1rem 1.4rem", color: "inherit",
              textDecoration: "none",
            }}>
              <span className="contact-label" style={{ display: "flex", alignItems: "center", gap: "0.5rem", flexShrink: 0 }}>
                <span style={{ color: C.accent, display: "flex", alignItems: "center" }}>{icon}</span>
                <span style={{ fontFamily: FONT_MONO, color: C.muted, fontSize: "0.75rem", letterSpacing: "1px" }}>
                  {label.toUpperCase()}
                </span>
              </span>
              <span style={{ fontFamily: FONT_MONO, color: C.accent, fontSize: "0.83rem", wordBreak: "break-all" }}>{val}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}